import * as Yup from 'yup';

const searchFormSchema = Yup.object().shape({
  prompt: Yup.string().trim().required().max(2000, 'Message too large.'),
});

export default searchFormSchema;
